import React, { useEffect, useState } from "react";

interface IThresholdProps {
    /**
     * Show children after a fixed amount of time (in ms).
     */
    threshold: number;
    children: React.ReactNode;
}

export function Threshold(props: IThresholdProps) {
    const { threshold, children } = props;

    const [show, setShow] = useState(false);

    if (!getShouldDelay(threshold) && !show) {
        setShow(true);
    }

    useEffect(() => {
        if (!getShouldDelay(threshold)) {
            return;
        }

        const timeout = setTimeout(() => {
            setShow(true);
        }, threshold);

        return () => {
            clearTimeout(timeout);
        };
    }, [threshold]);

    if (!show) {
        return null;
    }

    return <>{children}</>;
}

function getShouldDelay(treshold: number): boolean {
    return treshold > 0;
}
